<template>
  <div>
    <!------------------------------------------>
    <!-- MODULES ------------------------------->
    <!------------------------------------------>
    <v-row no-gutters class="px-12 py-2 pt-4">
      <v-col cols="12">
        <Modules />
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- INTEGRATIONS -------------------------->
    <!------------------------------------------>
    <v-row no-gutters class="px-12 py-2">
      <v-col cols="12">
        <Integrations />
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- COMPLEMENTS --------------------------->
    <!------------------------------------------>
    <v-row no-gutters class="px-12 py-2">
      <v-col cols="12">
        <Complements />
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- GATEWAYS ------------------------------>
    <!------------------------------------------>
    <v-row no-gutters class="px-12 py-2">
      <v-col cols="12">
        <Gateways />
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- AFRUS ENGINE BY GATEWAY --------------->
    <!------------------------------------------>
    <v-row no-gutters class="px-12 py-2">
      <v-col cols="12">
        <AfrusEngineByGateway />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Modules from '@/components/Organization/Settings/Modules'
import Integrations from '@/components/Organization/Settings/Integrations'
import Complements from '@/components/Organization/Settings/Complements'
import Gateways from '@/components/Organization/Settings/Gateways'
import AfrusEngineByGateway from '@/components/Organization/Settings/AfrusEngineByGateway'

export default {
  name: 'organizationSettings',
  components: {
    Modules,
    Integrations,
    Complements,
    Gateways,
    AfrusEngineByGateway
  },
  data() {
    return {
      isLoading: false
    }
  },
  async created() {},
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
